import React, { useEffect, useState } from 'react';
import { Container, Table, Button } from 'react-bootstrap';
import apiCall from '../../utils/apiUtils';

const AdminCashoutPage: React.FC = () => {
  const [rows, setRows] = useState<any[]>([]);
  const refresh = () => apiCall('/AdminListCashouts', null, (res: any)=>setRows(Array.isArray(res)?res:[]), 'GET');
  useEffect(()=>{ refresh(); }, []);

  const markPaid = (id: number) => apiCall('/AdminMarkPaid', { id }, (res:any)=>{ if (res?.success) refresh(); }, 'POST');
  const del = (id: number, amount: number, uid: number, status: string) => {
    if (status !== 'unpaid') return;
    apiCall('/DeleteCashout', { id }, (res:any)=>{ if (res?.success) refresh(); }, 'POST');
  };

  return (
    <Container>
      <h2>Cashout Admin</h2>
      <Table size="sm" bordered>
        <thead><tr><th>ID</th><th>User</th><th>Amount</th><th>Status</th><th>Date</th><th>Actions</th></tr></thead>
        <tbody>
          {rows.map(r=> (
            <tr key={r.id}>
              <td>{r.id}</td>
              <td>{r.vLoginName} (#{r.nUserId})</td>
              <td>{r.amount}</td>
              <td>{r.status}</td>
              <td>{r.dDate}</td>
              <td className="d-flex gap-2">
                {r.status==='unpaid' && <Button size="sm" onClick={()=>markPaid(r.id)}>Mark Paid</Button>}
                {r.status==='unpaid' && <Button size="sm" variant="danger" onClick={()=>del(r.id, r.amount, r.nUserId, r.status)}>Delete</Button>}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </Container>
  );
};

export default AdminCashoutPage;
